import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { apiFetch } from '@/lib/api';
import { useSession, useMe } from '@/lib/auth';
import { useT } from '@/lib/i18n';

// AccountLocked — tela cheia mostrada quando a PRÓPRIA conta está agendada para
// exclusão. A conta fica bloqueada em tudo (o backend 403 nas demais rotas); aqui só
// resta cancelar (admin) ou sair.
export function AccountLocked({ runAfter }: { runAfter?: string }) {
  const t = useT();
  const qc = useQueryClient();
  const { logout } = useSession();
  const { data: me } = useMe(true);
  const mins = runAfter ? Math.max(0, Math.round((new Date(runAfter).getTime() - Date.now()) / 60000)) : 0;

  const cancel = async () => {
    const r = await apiFetch('POST', '/account/delete/cancel');
    if (!r.ok) { toast.error(t('account.del.cancelFailed')); return; }
    toast.success(t('account.del.canceledToast'));
    qc.invalidateQueries({ queryKey: ['account-deletion-status'] });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md rounded-2xl border border-destructive/30 bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-full bg-destructive/12">
          <AlertTriangle className="size-7 text-destructive" />
        </div>
        <h1 className="text-xl font-bold">{t('account.del.lockedTitle')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('account.del.lockedBody', { mins })}</p>
        {me?.role === 'admin' ? (
          <Button className="mt-6 w-full" onClick={cancel}>{t('account.del.cancel')}</Button>
        ) : (
          <p className="mt-6 rounded-lg border bg-muted/30 p-3 text-sm text-muted-foreground">{t('account.del.lockedMember')}</p>
        )}
        <button onClick={logout} className="mt-4 text-sm text-muted-foreground transition-colors hover:text-foreground">{t('nav.logout')}</button>
      </div>
    </div>
  );
}
